var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgObject3D3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.125 10.3806V5.38055C13.1248 5.16135 13.0669 4.94606 12.9572 4.75628C12.8475 4.5665 12.6898 4.40891 12.5 4.2993L8.125 1.7993C7.93498 1.68959 7.71942 1.63184 7.5 1.63184C7.28058 1.63184 7.06502 1.68959 6.875 1.7993L2.5 4.2993C2.31016 4.40891 2.15249 4.5665 2.04279 4.75628C1.93309 4.94606 1.87522 5.16135 1.875 5.38055V10.3806C1.87522 10.5998 1.93309 10.815 2.04279 11.0048C2.15249 11.1946 2.31016 11.3522 2.5 11.4618L6.875 13.9618C7.06502 14.0715 7.28058 14.1293 7.5 14.1293C7.71942 14.1293 7.93498 14.0715 8.125 13.9618L12.5 11.4618C12.6898 11.3522 12.8475 11.1946 12.9572 11.0048C13.0669 10.815 13.1248 10.5998 13.125 10.3806Z",
    stroke: "#0E131F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.6875 3.01172L7.5 4.63672L10.3125 3.01172",
    stroke: "#0E131F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.6875 12.7496V9.50586L1.875 7.88086",
    stroke: "#0E131F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.125 7.88086L10.3125 9.50586V12.7496",
    stroke: "#0E131F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.04395 4.73047L7.5002 7.88672L12.9564 4.73047",
    stroke: "#0E131F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 14.1809V7.88086",
    stroke: "#0E131F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgObject3D3);
export default __webpack_public_path__ + "static/media/object3d3.97f3cfdb3061cda697edca10b64b7d52.svg";
export { ForwardRef as ReactComponent };